<template>

  <b-modal size="lg" v-model="isVisible" @hidden="onHidden" hide-footer>

    <b-alert show :variant="messageAlert.variant" class="p-2 text-center">
      {{ messageAlert.text }}
    </b-alert>

    <b-card>

      <h4 class="text-center font-weight-bold text-primary mb-2">
        SOLICITUD-ANATOMIA PATOLOGICA
      </h4>

      <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-success">
        <b-tab title="ESTUDIO / RESUMEN" active>
          <b-card>
            <b-row>
              <b-col cols="4">
                <span class="text-info">Servicio:</span>
                <b-form-radio-group v-model="form1.servicio" :options="opServicios" />
              </b-col>

              <b-col cols="2">
                <span class="text-info">Prioridad:</span>
                <b-form-radio-group v-model="form1.prioridad" :options="opPrioridad" />
              </b-col>

              <div class="col-5">
                <span class="text-info">Fecha y Hora de toma:</span>
                <b-form-input type="datetime-local" v-model="form1.fechaHoraToma" class="col-10" />
              </div>


            </b-row>

            <hr class="my-2">

            <div class="mt-1">
              <div class="my-1">
                <span class="text-info">Estudio Solicitado:</span>
                <b-form-radio-group v-model="form1.estudioSolicitado" :options="opEstudios" class="mb-1">
                </b-form-radio-group>
              </div>

              <div class="my-1">
                <span class="text-info">Descripcion estudio solicitado:</span>
                <b-form-textarea v-model="form1.descripcionEstudio" />
              </div>
            </div>

            <hr class="my-2" />

            <b-row class="mt-1">

              <div class="col-12 mb-1">
                <span class="text-info">Cuadro clinico:</span>
                <b-form-textarea v-model="form1.cuadroClinico" />
              </div>

              <div class="col-12 mb-1">
                <span class="text-info">Resultados de laboratorio:</span>
                <b-form-textarea v-model="form1.resultadosLaboratorio" />
              </div>

              <div class="col-12 mb-1">
                <span class="text-info">Datos imagen:</span>
                <b-form-textarea v-model="form1.datosImagen" />
              </div>

              <div class="col-12 mb-1">
                <span class="text-info">Tratamiento:</span>
                <b-form-textarea v-model="form1.tratamiento" />
              </div>
            </b-row>

          </b-card>
        </b-tab>

        <b-tab title="DATOS CITOLOGIA VAGINAL">
          <b-card>

            <b-row>
              <span class="text-info">Material:</span>
              <b-form-checkbox-group v-model="form2.materiales" :options="opsMaterial" />
            </b-row>

            <div class="row my-2">
              <span class="text-info">Descripcion Macroscopica:</span>
              <b-form-textarea v-model="form2.macroscopica" />
            </div>

            <div class="row my-2">
              <span class="text-info">Diagnostico de ultima citologia:</span>
              <b-form-textarea v-model="form2.ultimaCitologia" />
            </div>

          </b-card>
        </b-tab>


        <b-tab title="MUESTRAS / RESPONSABLES">
          <b-card>
            <label>
              Muestra o Pieza / Número
            </label>
            <i class="fa-solid fa-circle-info ml-1" style="cursor: pointer;"
              title="Describir el origen y numero de muestras enviadas" />

            <b-form-textarea v-model="form3.muestras" />

            <hr class="my-3" />


            <div class="row d-flex align-items-center">
              <label class="col-3">Profesional que solicita:</label>
              <SearchOpts v-model="form3.doctor" :searchService="getDoctoresByEstablecimiento"
                :placeholder="'Buscar doctor responsable...'" :minChars="3" class="col" />
            </div>

            <div class="row d-flex align-items-center my-2">
              <label class="col-3">Fecha y hora de solicitud:</label>
              <b-form-input type="datetime-local" v-model="form3.fechaHoraSolicitud" class="form-control col-4 mx-1" />
            </div>


            <div class="row d-flex align-items-center mt-3">
              <label class="col-3">Entrega la muestra :</label>
              <SearchOpts v-model="form3.entregaMuestra" :searchService="getAuxiliarMedicoByEstablecimiento"
                :placeholder="'Buscar profesional responsable...'" :minChars="3" class="col" />
            </div>

            <div class="row d-flex align-items-center mt-2">
              <label class="col-3">Recibe la muestra:</label>
              <SearchOpts v-model="form3.recibeMuestra" :searchService="getAuxiliarMedicoByEstablecimiento"
                :placeholder="'Buscar profesional responsable...'" :minChars="3" class="col" />
            </div>


            <div class="row d-flex align-items-center my-2">
              <label class="col-3">Fecha hora de recepcion:</label>
              <b-form-input type="datetime-local" v-model="form3.fechaHoraRecepcion" class="form-control col-4 mx-1" />
            </div>
          </b-card>
        </b-tab>
        <b-tab title="SEMIOLOGIA GINECOLOGICA">
          
          <div
            v-for="(pair, index) in pairedOptions"
            :key="'pair-' + index"
            class="row mb-1"
          >
            <div
              v-for="(opcion, subIndex) in pair"
              :key="'option-' + subIndex"
              class="col-6"
            >
              <div v-if="opcion" class="d-flex align-items-center">
                <label :for="opcion.variable" class="col-7">
                  {{ opcion.label }}:
                </label>
                <b-form-input
                  v-model="dataAntecedentes[opcion.variable]"
                  type="text"
                  class="col-5"
                  :id="opcion.variable"
                  :maxlength="opcion.tipo === 'number' ? 2 : null"
                  @keypress="opcion.tipo === 'number' ? onlyNumbers($event) : null"
                  :placeholder="opcion.tipo === 'date' ? 'descripcion' : null"
                />
              </div>
            </div>
          </div>

          <div>
            <b-row>
              <span class="text-info">Anticonceptivos:</span>
              <b-form-checkbox-group v-model="anticonceptivos" :options="anticonceptionOpts" />
            </b-row>
          </div>
        </b-tab>
      </b-tabs>
      
      <div class="text-right mt-3" >
        <b-button variant="success" @click="onSave">
          Guardar
        </b-button>
      </div>
    </b-card>
  </b-modal>
</template>

<script>

import {
  BRow,
  BCol,
  BCard,
  BFormInput,
} from "bootstrap-vue";
import "flatpickr/dist/flatpickr.css";
import { onlyNumbers } from "@/shared/helpers";
import { doctoresService, auxiliarService } from "@/shared/services";
import { SearchOpts, } from '@/shared/components';
import { auxiliarMedicoService } from "@/views/administracion/services";
import { getEstablecimientoLS } from "@/shared/helpers";
import { procedimientosFormulariosService } from "../../services/procedimientosFormulariosService";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormInput,
    SearchOpts
  },

  props: {
    isProceso: {
      type: Boolean,
      default: false
    },

    isLabAs400: {
      type: Boolean,
      default: false
    },

    isLabAux: {
      type: Boolean,
      default: false
    }
  },


  created() {
    this.getData();
  },


  data() {
    return {
      tokenPrincipal: null,
      isVisible: false,
      formGeneral: null,
      anticonceptionVSelect: [],
      anticonceptivos:null,
      idRegistroForm: null,
      messageAlert: {
        message: null,
        variant: null
      },
      form1: {
        servicio: null,
        prioridad: null,
        fechaHoraToma: null,
        estudioSolicitado: null,
        descripcionEstudio: null,

        cuadroClinico: null,
        resultadosLaboratorio: null,
        datosImagen: null,
        tratamiento: null,
      },
      form2: {
        materiales: [],
        macroscopica: null,
        ultimaCitologia: null,
      },
      form3: {
        muestras: null,
        doctor: null,
        fechaHoraSolicitud: null,
        entregaMuestra: null,
        recibeMuestra: null,
        fechaHoraRecepcion: null
      },
      doctoresService,
      auxiliarService,
      anticonceptionOpts: [
        { text: 'ORAL O INYECTABLE', value: '1' },
        { text: 'DIU', value: '2' },
        { text: 'LIGADURA', value: '3' },
        { text: 'BARRERA', value: '4' },
        { text: 'Muñon Cervical', value: '5' },
        { text: 'OTRO', value: '5' }
      ],
      opsMaterial: [
        { text: 'Endocervix', value: '1' },
        { text: 'Exocervix', value: '2' },
        { text: 'Pared Vaginal', value: '3' },
        { text: 'Union Escamo', value: '4' },
        { text: 'Muñon Cervical', value: '5' }
      ],
      opEstudios: [
        { value: "1", text: "Histopatologia" },
        { value: "2", text: "Citologia" },
        { value: "3", text: "Revision de laminillas" },
        { value: "4", text: "Transoperatorio" },
        { value: "5", text: "Otros tipos de estudio" },
      ],
      opServicios: [
        { value: "1", text: "Emergencia" },
        { value: "2", text: "Consulta Externa" },
        { value: "3", text: "Hospitalizacion" },
      ],
      opPrioridad: [
        { value: "1", text: "Urgente" },
        { value: "2", text: "Rutina" },
      ],
      dataAntecedentes: {
        menarquia: "",
        menopausia: "",
        inicioSexual: "",
        gestas: "",
        partos: "",
        abortos: "",
        cesareas: "",
        terapiaHormonal: "",
        ultimaMenstruacion: "",
        ultimoParto: "",
        ultimoCitologia: ""
      },

      opciones: [
        {
          label: "Edad Menarquia",
          variable: "menarquia",
          tipo: "number"
        },
        {
          label: "Edad Menopausia",
          variable: "menopausia",
          tipo: "number"
        },
        {
          label: "Edad inicio vida sexual",
          variable: "inicioSexual",
          tipo: "number"
        },
        {
          label: "Número de gestas",
          variable: "gestas",
          tipo: "number"
        },
        {
          label: "Número de partos",
          variable: "partos",
          tipo: "number"
        },
        {
          label: "Número de abortos",
          variable: "abortos",
          tipo: "number"
        },
        {
          label: "Número de cesáreas",
          variable: "cesareas",
          tipo: "number"
        },
        {
          label: "Terapia hormonal",
          variable: "terapiaHormonal",
          tipo: "text"
        },
        {
          label: "Fecha última menstruación",
          variable: "ultimaMenstruacion",
          tipo: "date"
        },
        {
          label: "Fecha último parto",
          variable: "ultimoParto",
          tipo: "date"
        },
        {
          label: "Fecha última citologia cervical",
          variable: "ultimoCitologia",
          tipo: "date"
        },
      ],
    };
  },



  methods: {

    async getDoctoresByEstablecimiento(search) {
      const establecimiento = getEstablecimientoLS();
      const responseDoctores = await doctoresService.searchDoctoresByTermSelect(search, establecimiento.id);

      const responseMap = responseDoctores.map(item => ({
        value: item.value,
        text: item.text,
        especialidad: item.especialidad
      }));

      return responseMap;
    },


    async getAuxiliarMedicoByEstablecimiento(search) {
      const establecimiento = getEstablecimientoLS();

      const params = {
        search,
        establecimiento: establecimiento.id
      }

      const responseAux = await auxiliarMedicoService.getAll(params);
      const auxiliares = responseAux?.auxiliares;
      const responseMap = auxiliares.map(item => ({
        value: item.id,
        text: item.text,
      }));

      return responseMap;
    },

    clearForm() {

      this.form1 = {
        servicio: null,
        prioridad: null,
        fechaHoraToma: null,
        estudioSolicitado: null,
        descripcionEstudio: null,

        cuadroClinico: null,
        resultadosLaboratorio: null,
        datosImagen: null,
        tratamiento: null,
      }

      this.form2 = {
        materiales: [],
        macroscopica: null,
        ultimaCitologia: null,
      }

      this.form3 = {
        muestras: null,
        doctor: null,
        fechaHoraSolicitud: null,
        entregaMuestra: null,
        recibeMuestra: null,
        fechaHoraRecepcion: null
      }

      this.dataAntecedentes = {
        menarquia: "",
        menopausia: "",
        inicioSexual: "",
        gestas: "",
        partos: "",
        abortos: "",
        cesareas: "",
        terapiaHormonal: "",
        ultimaMenstruacion: "",
        ultimoParto: "",
        ultimoCitologia: ""
      },

      this.anticonceptivos = null,

      this.messageAlert = {
        message: null,
        variant: null
      }
    },


    async getData() {
      this.clearForm();
      this.tokenPrincipal = this.$route.query["13alab"];
      if (!this.tokenPrincipal) return;
      const responseFormulario = await procedimientosFormulariosService.getByTokenPrincipal(this.tokenPrincipal, '13alab');
      if (!responseFormulario || !responseFormulario.length) {
        this.messageAlert = {
          text: 'No existe informacion registrada',
          variant: 'info'
        };
        this.isVisible = true;
        return;
      }
      const dataF13a = responseFormulario[0];
      this.idRegistroForm = dataF13a.id;
      delete dataF13a.id;
      if (dataF13a.dataJson) {
        const dataForm = JSON.parse(dataF13a.dataJson);
        this.messageAlert = {
          text: 'Informacion registrada',
          variant: 'success'
        };
        if (dataForm.form1) this.form1 = dataForm.form1;
        if (dataForm.form2) this.form2 = dataForm.form2;
        if (dataForm.form3) this.form3 = dataForm.form3;
        if (dataForm.semiologia) this.dataAntecedentes = dataForm.semiologia.antecedentes;
        if (dataForm.semiologia) this.anticonceptivos = dataForm.semiologia.anticonceptivos;
      }
      this.isVisible = true;
    },


    async onSave() {
      this.isVisible = false;
      this.formGeneral.semiologia = {
        antecedentes: this.dataAntecedentes,
        anticonceptivos: this.anticonceptivos,
      };
      const dataJson = JSON.stringify(this.formGeneral);
      const params = {
        nameForm: '13alab',
        dataJson: dataJson,
        idRegistroForm: this.idRegistroForm,
        tokenProceso: this.isProceso ? this.tokenPrincipal : null,
        tokenLabAux: this.isLabAux ? this.tokenPrincipal : null,
        tokenLabAs400: this.isLabAs400 ? this.tokenPrincipal : null
      }
      const responseSave = await procedimientosFormulariosService.guardarData(params);
      if (!responseSave) {
        await this.$swal({
          title: "Error",
          text: "No se guardo! Contacte al equipo de desarrollo",
          icon: "error",
          confirmButtonColor: "#089599",
        });

        return;
      }
      await this.$swal({
        title: "Guardado",
        text: "Guardado correctamente",
        icon: "success",
        confirmButtonColor: "#089599",
      });
      this.isVisible = false;
    },


    onHidden() {
      this.isVisible = false;
    },

  },

  computed: {
    pairedOptions() {
      const pairs = [];
      for (let i = 0; i < this.opciones.length; i += 2) {
        pairs.push([this.opciones[i], this.opciones[i + 1] || null]);
      }
      return pairs;
    },
  },  

  watch: {

    '$route.query.13alab': {
      handler() {
        this.getData();
      },
    },


    form1: {
      deep: true,
      handler(newValue) {
        this.formGeneral = {
          ...this.formGeneral,
          form1: newValue
        }
      }
    },


    form2: {
      deep: true,
      handler(newValue) {

        this.formGeneral = {
          ...this.formGeneral,
          form2: newValue
        }
      }
    },

    form3: {
      deep: true,
      handler(newValue) {
        this.formGeneral = {
          ...this.formGeneral,
          form3: newValue
        }
      }
    },



    isVisible: {
      deep: true,
      handler(newValue) {
        if (!newValue) {
          const updatedQuery = { ...this.$route.query };
          delete updatedQuery["13alab"];
          this.$router.push({ path: this.$route.path, query: updatedQuery });
        }
      }
    }
  },
};
</script>
